import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {ProtestosFichasModel} from "./protestos-fichas.model";
import {ProtestosFichasService} from "./protestos-fichas.service";


@Component({
  selector: 'app-protestos-fichas-form',
  templateUrl: './protestos-fichas-form.component.html'
})
export class ProtestosFichasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  protesto: ProtestosFichasModel = new ProtestosFichasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private protestosFichasService: ProtestosFichasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_protesto: [],
      protesto_pt: ['', [
        Validators.required
      ]],
      protesto_en: ['', [
        Validators.required
      ]],
      protesto_es: ['', [
        Validators.required
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_protesto'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarProtesto');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarProtesto') : this.func.traduzir('front.cadastrarNovaProtesto');
      }

      if (!id) {
        return;
      }

      this.protestosFichasService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarProtesto')+': '+json.Payload[0].protesto_pt;
            }else{
              this.title = this.func.traduzir('front.visualizarProtesto') + ': ' + json.Payload[0].protesto_pt;
            }
            this.protesto = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.form.value;

    if (values.id_protesto) {
      result = this.protestosFichasService.editar(values, values.id_protesto);
    } else {
      result = this.protestosFichasService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'fichas', 'protestos']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/protestos-fichas/protestos-fichas-form.component.ts